import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { ToastService } from "ng-uikit-pro-standard";

@Component({
  selector: "app-button-drop",
  templateUrl: "./button-drop.component.html",
  styleUrls: ["./button-drop.component.scss"],
})
export class ButtonDropComponent implements OnInit {
  constructor(    private toastrService: ToastService) {}

  ngOnInit() {}

  @Input() droppedMetaButton = [];
  @Output() droppedButtonEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() buttonDeletedEvent = new EventEmitter<any>();

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }


  onButtonDrop(event: DragEvent) {
    event.preventDefault();
    const button = event.dataTransfer.getData("application/json");
    const buttonData = event.dataTransfer.getData("application/json");

    if (buttonData) {
      const { button, index } = JSON.parse(buttonData);
      if (button && index !== undefined) {
        this.droppedMetaButton.splice(index, 1);
      }
    }

    if (button.length > 0) {
      // if (button.buttontype =="common" ) {

      const metabutton = JSON.parse(button);
      console.log("Field:", metabutton);
      // this.buttonDeletedEvent.emit(metabutton);

      // if (metabutton.id.startsWith("mb1")) {
        if (metabutton.hasOwnProperty("buttontype")) {

        this.droppedMetaButton.push(metabutton);
        this.droppedButtonEvent.emit(metabutton);
        // this.droppedButtonEvent.emit({ button: JSON.stringify(metabutton) });

        console.log("Dropped Button:", this.droppedMetaButton);
        console.log("Button data:", metabutton);
      } else {
        console.log("Not a Button type, Drop not accepted.");

        this.showWarning("Not a Button type, Drop not accepted");

        // console.log("Type Deleted", index);
        // const field = this.droppedMetaButton[index];
        // this.droppedMetaButton.splice(index, 1);
      }
    }
  }
  onDragover(event: DragEvent) {
    event.preventDefault();
  }

  // onDragStart(event: DragEvent, button: any, index: number) {
  //   event.dataTransfer.setData(
  //     "application/json",
  //     JSON.stringify({ button, index })
  //   );
  // }

  deleteButton(index: number) {
    console.log("Type Deleted", index);
    const button = this.droppedMetaButton[index];
    this.buttonDeletedEvent.emit(button);
    this.droppedMetaButton.splice(index, 1);
  }
}
